import { ILogger } from '../logging';
import { NavbarItemEnum } from '../models/app';

/**
 * This is an extra check to prevent open redirects.
 * @param redirectUrl
 * @returns redirectUrl validity
 */
export const checkRedirectUrl = (redirectUrl: string, logger?: ILogger): boolean => {
  const test = /^\/[^\/].*/.test(redirectUrl);

  if (!test) {
    logger?.error(`Invalid return url (${redirectUrl}). The return url needs to be relative.`);
  }

  return test;
};

export interface RouteData {
  requiresCompteClient?: boolean;
  hideNavbar?: boolean;
  feature?: NavbarItemEnum;
  analyticsPageTitle?: string;
}

export const requiresCompteClientRouteData: RouteData = {
  requiresCompteClient: true,
};

export const hideNavbarRouteData: RouteData = {
  hideNavbar: true,
};

export const featureRouteData = (feature: NavbarItemEnum): RouteData => ({ feature });

export const analyticsRouteData = (analyticsPageTitle: string): RouteData => ({ analyticsPageTitle });
